import React from 'react';
import { fetchLoans } from 'actions/loans';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { date } from 'utils/date';
import { dollars } from 'utils/money';
import LoanDialog from 'components/Loans/LoanDialog';
import BankDialog from 'components/Loans/BankDialog';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { updateLoan } from 'actions/loans';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import { toggleNotification } from '/actions/commonActions';

const styles = theme => ({
  responsiveTable: {
    overflowX: 'scroll'
  },
  overDue: {
    backgroundColor: '#EF9A9A',
  },
  dueToday: {
    backgroundColor: '#FFE082',
  },
});

export class List extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchLoans());
  }

  classSelector = (repaymentDatetime) => {
    const timeDiff = moment().diff(moment(repaymentDatetime));
    if ( timeDiff >= 0) {
      return this.props.classes.overDue;
    } else if (moment(repaymentDatetime).isSame(moment(), 'day')) {
      return this.props.classes.dueToday;
    }
  }

  bank = (loan) => ({ bankName: loan.bankName, AccountNo: loan.bankAccountNo, BSB: loan.bankBsb });

  handleStatusChange = (loanId, event) => {
    this.props.dispatch(updateLoan(loanId, {loan: { status: event.target.value }}));
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} style={{position: 'absolute', zIndex: '1', top: '50%', left: '50%'}}/>
      );
    }
  }

  renderStatus = (loan) => {
    return (
      <Select
        value={loan.status}
        onChange={(event) => {this.handleStatusChange(loan.id, event)}}
      >
        <MenuItem value={'waiting_for_drawdown'}>Waiting For Drawdown</MenuItem>
        <MenuItem value={'repayment_in_progress'}>Repayment In Progress</MenuItem>
        <MenuItem value={'early_termination'}>Early Termination</MenuItem>
        <MenuItem value={'paid_off'}>Paid Off</MenuItem>
        <MenuItem value={'default'}>Default</MenuItem>
      </Select>
    );
  }

  renderNotification = () => {
    if (this.props.notificationMsg) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!!this.props.notificationMsg}
          onClose={()=>{this.props.dispatch(toggleNotification())}}
          message={<span id='message-id'>{this.props.notificationMsg}</span>}
        />
      );
    }
  }

  renderLoans = () => {
    return (
      <div>
        { this.renderNotification() }
        { this.renderSpinner() }
        <Table className={this.props.classes.responsiveTable}>
          <TableHead>
            <TableRow>
              <TableCell>Loan Number</TableCell>
              <TableCell>Application Number</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Schedules</TableCell>
              <TableCell>Org</TableCell>
              <TableCell>Principal</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Repayment Frequency</TableCell>
              <TableCell>Term Length</TableCell>
              <TableCell>Term Unit</TableCell>
              <TableCell>Drawdown Date</TableCell>
              <TableCell>Bank Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              Object.values(this.props.loans).map(loan => {
                return (
                  <TableRow key={`loan${loan.loanNumber}`} >
                    <TableCell>
                      { loan.loanNumber }
                    </TableCell>
                    <TableCell>
                      <Link to={`/applications/${loan.applicationNumber}`}>
                        { loan.applicationNumber }
                      </Link>
                    </TableCell>
                    <TableCell>{this.renderStatus(loan)}</TableCell>
                    <TableCell>
                      {
                        <LoanDialog
                          loan={loan}
                          buttonLabel='View'
                        />
                      }
                    </TableCell>
                    <TableCell>
                      <Link to={`/organisations/${loan.organisation.id}`}>
                        { loan.organisation.name }
                      </Link>
                    </TableCell>
                    <TableCell>
                      { dollars(loan.principal) }
                    </TableCell>
                    <TableCell>
                      {`${loan.interestRate}%`}
                    </TableCell>
                    <TableCell>
                      { loan.repaymentFrequency }
                    </TableCell>
                    <TableCell>
                      { loan.termLength }
                    </TableCell>
                    <TableCell>
                      { loan.termUnit }
                    </TableCell>
                    <TableCell>
                      { date(loan.drawdownDate) }
                    </TableCell>
                    <TableCell>
                      {
                        <BankDialog
                          bank={this.bank(loan)}
                          buttonLabel='View'
                        />
                      }
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </div>
    );
  }

  render = () => {
    if (!this.props.loans) {
      return null;
    }
    return (
      <div>
        <Typography variant='headline'>
          Loans
        </Typography>
        { this.renderLoans() }
      </div>
    );
  };
}


const mapStateToProps = (state, ownProps) => {
  return {
    loans: state.loans.loans,
    showSpinner: state.app.showSpinner,
    notificationMsg: state.app.notificationMsg
  }
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Loans/List.js